<template>
  <div class="relevancy">
    <div class="container">
      <div class="relevancy__row" v-if="dataMissing">
        <div class="relevancy__no-data">Awaiting Data</div>
      </div>
      <div class="relevancy__row" v-else-if="dataFetchingCount !== 0">
        <div class="relevancy__loader">
          <base-loader/>
        </div>
      </div>
      <div v-else class="relevancy__row">
        <base-content-block class="relevancy__row-item"
                            title="Relevancy Score Breakdown"
                            slotLess="true">
          <div v-if="isScoreAbsent"
               class="no-data-block">
            Awaiting Data
          </div>
          <div class="relevancy__chart-wrapper" v-else>
            <breakdown :data="breakdown"/>
          </div>
        </base-content-block>
        <base-content-block class="relevancy__row-item"
                            title="Keyword Relevancy Score"
                            slotLess="true">
          <keyword :data="keywords"/>
        </base-content-block>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Keyword from './Keyword'
import Breakdown from '../rank-zone/overview/Breakdown'

/**
 * Relevancy Report component
 */
export default {
  name: 'RelevancyReport',
  components: {
    Keyword,
    Breakdown
  },
  created () {
    if (this.selectedClient) {
      this.loadPageData()
    }
  },
  data () {
    return {
      // we use number flag here instead of isFetched boolean flag to avoid edge cases by multiply api calls when one call cancels
      // previous call and finally after receiving data isFetched still false
      dataFetchingCount: null
    }
  },
  computed: {
    ...mapState({
      selectedClient: 'selectedClient'
    }),
    ...mapState('relevancyReport', {
      keywords (state) {
        const list = state.keywords.sort((item1, item2) => item2.score - item1.score)
        return { list, total: state.keywordsTotal }
      },
      breakdown (state) {
        return state.breakdown.sort((item1, item2) => item2.score - item1.score)
      }
    }),
    isDataEmpty () {
      return (!this.keywords || this.keywords.length === 0) ||
        (!this.breakdown || this.breakdown.length === 0)
    },
    dataMissing () {
      return this.dataFetchingCount === 0 && this.isDataEmpty
    },
    isScoreAbsent () {
      return !this.breakdown || !this.breakdown.length
    }
  },
  methods: {
    ...mapActions('relevancyReport', [ 'getRelevancyData' ]),
    async loadPageData () {
      if (this.dataFetchingCount === null) {
        this.dataFetchingCount = 0
      }
      this.dataFetchingCount++
      await this.getRelevancyData({ clientId: this.clientId })
      this.dataFetchingCount--
    }
  },
  watch: {
    selectedClient (client) {
      if (!client) {
        return
      }
      this.loadPageData(this.clientId)
    }
  }
}
</script>

<style scoped lang="scss">
  .relevancy {
    &__no-data {
      display: flex;
      flex: 1 1 100%;
      height: 300px;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
    }
    &__loader {
      display: flex;
      width: 100%;
      justify-content: center;
      height: calc(100vh - 530px);
      align-items: center;
    }

    &__download {
      position: absolute;
      top: 0;
      right: 5px;
    }

    &__row {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      margin-bottom: 14px;

      &-item {
        flex: 1 1 100%;
        overflow: hidden;

        &:first-child {
          margin-right: 14px;
        }
      }
    }

    &__chart-wrapper {
      width: 100%;
      padding: 60px 0 60px 40px;
      box-sizing: border-box;
    }
  }
</style>
